import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthPageWrapper from '../../components/AuthWrapper/AuthPageWrapper';
import { appContext } from '../../service/AppContext';
import './Broadcast.css';

const STATE_LABELS = {
    pending:          'ממתין',
    live:             'משדר',
    ended_processing: 'בעיבוד',
    published:       'פורסם',
    failed:           'נכשל',
    orphan:           'ללא התאמה',
};

export default function BroadcastList() {
    const { breslevRequest } = useContext(appContext);
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [stateFilter, setStateFilter] = useState('');

    useEffect(() => {
        (async () => {
            const params = { page, size: 20 };
            if (stateFilter) params.state = stateFilter;
            const res = await breslevRequest({ method: 'GET', route: '/broadcast/', params });
            if (res?.status === 200) {
                setItems(res.data.broadcasts || []);
                setPages(res.data.pages || 1);
            }
        })();
    }, [page, stateFilter, breslevRequest]);

    return (
        <AuthPageWrapper roles={['ContentManager', 'Admin']}>
            <div className='video-page-wrepper'>
                <div className='video-page'>
                    <div className='page-header bl-list-header'>
                        <span>שידורים</span>
                        <button className='upload-button' onClick={() => navigate('/broadcast/new')}>+ התחל שידור חדש</button>
                    </div>
                    <hr />
                    <div className='bl-filter-row'>
                        <label>סטטוס:</label>
                        <select value={stateFilter} onChange={e => { setStateFilter(e.target.value); setPage(1); }}>
                            <option value=''>הכל</option>
                            {Object.entries(STATE_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                        </select>
                    </div>
                    <table className='bl-table'>
                        <thead>
                            <tr>
                                <th>תאריך</th>
                                <th>שפה</th>
                                <th>כותרת</th>
                                <th>סטטוס</th>
                                <th>מפתח שידור</th>
                                <th>פוסט באתר</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map(b => (
                                <tr key={b.id}>
                                    <td>{(b.started_at || '').replace('T', ' ').slice(0, 16)}</td>
                                    <td>{b.language_code}</td>
                                    <td>{b.title}</td>
                                    <td className={'bl-state bl-state-' + b.state}>{STATE_LABELS[b.state] || b.state}</td>
                                    <td dir='ltr'>{b.stream_key}</td>
                                    <td>
                                        {b.wp_post_url
                                            ? <a href={b.wp_post_url} target='_blank' rel='noreferrer'>צפייה</a>
                                            : '-'}
                                    </td>
                                    <td>
                                        <Link to={`/broadcast/${b.id}`}>פרטים</Link>
                                    </td>
                                </tr>
                            ))}
                            {!items.length && (
                                <tr><td colSpan={7} className='bl-empty'>אין שידורים</td></tr>
                            )}
                        </tbody>
                    </table>
                    <div className='bl-pagination'>
                        <button disabled={page <= 1} onClick={() => setPage(p => p - 1)}>הקודם</button>
                        <span>{page} / {pages}</span>
                        <button disabled={page >= pages} onClick={() => setPage(p => p + 1)}>הבא</button>
                    </div>
                </div>
            </div>
        </AuthPageWrapper>
    );
}
